/* eslint-disable indent */
import { SET_CHAT_REQUEST, SET_CHAT_REQUEST_USERS, SET_STORY_DISCUS, SET_CHAT_MEETING_USERS, SET_CHAT_DATE_UTC, SET_CHAT_SCHEDULE_USERS, SET_MESSAGE_USERS, SET_OPEN_CHAT, SET_NO_READR_MESSAGES, SET_MEET_REVIEW } from './constants'

export const initialState = {
  chatRequest: {},
  requestUsers: {},
  meetingUsers: {},
  scheduleUsers: {},
  discusStory: {},
  utc: '',
  onGetMessages: false,
  openChat: false,
  noReadMessages: [],
  meetReview: {},
}

export const reducer = (state = initialState, action) => {
  const { type, payload } = action

  switch (type) {
    case SET_CHAT_REQUEST:
      return { ...state, chatRequest: payload }
    case SET_CHAT_REQUEST_USERS:
      return { ...state, requestUsers: payload }
    case SET_STORY_DISCUS:
      return { ...state, discusStory: payload }
    case SET_CHAT_MEETING_USERS:
      return { ...state, meetingUsers: payload }
    case SET_CHAT_SCHEDULE_USERS:
      return { ...state, scheduleUsers: payload }
    case SET_CHAT_DATE_UTC:
      return { ...state, utc: payload }
    case SET_MESSAGE_USERS:
      return { ...state, onGetMessages: payload }
    case SET_OPEN_CHAT:
      return { ...state, openChat: payload }
    case SET_NO_READR_MESSAGES:
      return { ...state, noReadMessages: payload }
    case SET_MEET_REVIEW:
      return { ...state, meetReview: payload }
    default:
      return state
  }
}
